import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { merge } from "rxjs";
import { combineLatest } from "rxjs";
import { BehaviorSubject } from "rxjs";
import { debounceTime, distinctUntilChanged, filter, map } from "rxjs/operators";

@Component({
    selector: "pager",
    templateUrl: "./pager.component.html",
    styleUrls: ["./pager.component.scss"]
})
export class PagerComponent implements OnInit {

    get startRecordIndex(): number { return Math.max((this.pageNumber - 1) * this.pageSize, 1); }
    get endRecordIndex(): number { return Math.min(this.pageNumber * this.pageSize, this.totalElements); }

    @Input() totalElements: number;
    @Input() totalPages: number;
    @Input() pageNumber: number;
    @Input() pageSize: number;

    temp: number;

    @Output() changed = new EventEmitter<{ pageNumber: number, pageSize: number }>();

    enterSubject = new BehaviorSubject("");
    inputSubject = new BehaviorSubject("");
    blurSubject = new BehaviorSubject("");

    constructor() {

        const correctInput = this.inputSubject.pipe(
            debounceTime(500),
            distinctUntilChanged(),
            map(i => parseInt(i, 10)),
            filter(i => i && 1 <= i && i <= this.totalPages)
        );

        correctInput.subscribe(i => this.temp = i);

        // combineLatest([merge([this.enterSubject, correctInput]), this.blurSubject]).pipe(

        // )
    }

    ngOnInit(): void {

    }

    begin() {

        this.pageNumber = 1;
        this.changed.next({ pageNumber: this.pageNumber, pageSize: this.pageSize });
    }

    prev() {
        this.pageNumber = this.pageNumber - 1;
        this.changed.next({ pageNumber: this.pageNumber, pageSize: this.pageSize });
    }

    next() {
        this.pageNumber = this.pageNumber + 1;
        this.changed.next({ pageNumber: this.pageNumber, pageSize: this.pageSize });
    }

    end() {
        this.pageNumber = this.totalPages;
        this.changed.next({ pageNumber: this.pageNumber, pageSize: this.pageSize });
    }

    pageSizeChange(pageSize: number) {

        this.changed.next({ pageNumber: this.pageNumber, pageSize });
    }
}
